import axios from "axios";

// Use relative /api paths so the app works on any domain (preview, production, custom)
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL || ""}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("appmi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.withCredentials = true;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("appmi_token");
      const path = window.location.pathname;
      if (path !== "/login" && path !== "/register" && path !== "/") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
